import axios from "axios";

// Create axios instance with default configuration
const Api = axios.create({
  //baseURL:   "http://localhost:3000/api/v1",
  baseURL: "https://funmiracles.com/api/v1",
  timeout: 10000, // 10 seconds timeout
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor - Add auth token to requests
Api.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem("Quizetoken");
    
    // If token exists, add it to the Authorization header
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => {
    // Handle request error
    return Promise.reject(error);
  }
);

// Response interceptor - Handle common errors
Api.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Handle response errors
    if (error.response) {
      // Server responded with error status
      const { status, data } = error.response;
      
      // Handle 401 Unauthorized - token expired or invalid
      if (status === 401) {
        // Clear auth data
        localStorage.removeItem("Quizetoken");
        localStorage.removeItem("userName");
        localStorage.removeItem("wallet");
        localStorage.removeItem("UserIdclient");
        localStorage.removeItem("UserIdMongo");
        localStorage.removeItem("GameId");
        localStorage.removeItem("gameLevel");
        
        // Redirect to homepage
        window.location.href = "/";
      }
      
      // Handle 403 Forbidden
      if (status === 403) {
        console.error("Access forbidden:", data?.message || "You don't have permission to access this resource");
      }
      
      // Handle 404 Not Found
      if (status === 404) {
        console.error("Resource not found:", data?.message || "The requested resource was not found");
      }
      
      // Handle 500 Server Error
      if (status >= 500) {
        console.error("Server error:", data?.message || "An internal server error occurred");
      }
    } else if (error.request) {
      // Request was made but no response received
      console.error("Network error:", "No response received from server. Please check your connection.");
    } else {
      // Something else happened
      console.error("Error:", error.message);
    }
    
    return Promise.reject(error);
  }
);

export default Api;

